import { render, staticRenderFns } from "./pop.vue?vue&type=template&id=ddaba816&"
import script from "./pop.vue?vue&type=script&lang=ts&"
export * from "./pop.vue?vue&type=script&lang=ts&"
import style0 from "./pop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports